module.exports = __webpack_public_path__ + "static/media/eduYellow.4ee434b9.svg";